import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface PageProps {
  title?: string;
  showBack?: boolean;
  /** Override default navigate(-1). */
  onBack?: () => void;
  noTabbar?: boolean;
  children: ReactNode;
}

export function Page({ title, showBack, onBack, noTabbar, children }: PageProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={`cs-page${noTabbar ? ' cs-page--no-tabbar' : ''}`}>
      {(title || showBack) && (
        <header className="cs-page__header">
          {showBack && (
            <button
              type="button"
              className="cs-page__back"
              onClick={() => (onBack ? onBack() : navigate(-1))}
              aria-label={t('common.back')}
            >
              ←
            </button>
          )}
          {title && <h1 className="cs-page__title">{title}</h1>}
        </header>
      )}
      <div className="cs-page__content">{children}</div>
    </div>
  );
}
